import { render, staticRenderFns } from "./FaqHeader.vue?vue&type=template&id=bc0c2804&"
import script from "./FaqHeader.vue?vue&type=script&lang=js&"
export * from "./FaqHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports